import { useState, useEffect } from "react";

export interface ImageReferences {
    coverImageURL: string;
    introImageURL: string;
    outroImageURL: string;
  }
  
  export type Template = {
    id: string;
    name: string;
    description: string;
    imageReferences: ImageReferences;
    coverImageURL: string | null;
    bRollContentAvailable: boolean;
  };

const useShowReelTemplates = (organizationId: number) => {
  const [templates, setTemplates] = useState<Template[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTemplates = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(
          `/api/v1/showreels/${organizationId}/org_templates`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch templates");
        }
        const data = await response.json();
        setTemplates(data.templates);
        setError(null);
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    if (organizationId) {
      fetchTemplates();
    }
  }, [organizationId]);
  return { templates, isLoading, error };
};

export default useShowReelTemplates;
